// @flow

import React, { useCallback, type Node } from 'react';
import styled from 'styled-components';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';

import { useSubmitError } from '@tectonics/prs/validation';

import { useFormStatusContext } from '@tectonics/prs/form-status/use-form-status-context';
import { isElementVisible } from '@tectonics/look-and-feel/commons/dom-utils';
import { useUserInputAsRadioButton } from '@tectonics/prs/user-input-values';

import { CaptchaForm } from '../captcha';
import { ErrorDisplay } from '../error-display';

import { PlaceOrderButtonPisp } from './place-order-button';
import { Terms } from './terms';
import { PixPispPaymentInformation } from '@tectonics/look-and-feel/uber-v2/organisms/pix-pisp-payment-information';
import { PixPaymentInformation } from '@tectonics/look-and-feel/uber-v2/organisms/pix-payment-information';
import { InformationBox } from '@tectonics/look-and-feel/uber-v2/organisms/information-box';

type Props = {|
  onSubmit: (boolean, boolean) => Promise<bool>,
|};

const FormElement = styled.form`
  display: grid;
  grid-gap: 16px;
  padding: 0 16px 32px;
  @media screen and (min-width: 840px) {
    padding: 32px;
  }
`;

export function Form({ onSubmit }: Props): Node {
  const formHasBeenSent = useFormHasBeenSent();
  const [selectedBank] = useUserInputAsRadioButton('selectedPixPispBank');

  const [, setFormStatus] = useFormStatusContext();

  const handleSubmit = useCallback((event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();
    (async () => {
      const hasErrors = Array.from(document.querySelectorAll('[data-error]'))
        .filter(isElementVisible).length > 0;

      setFormStatus('sent');
      await onSubmit(formHasBeenSent, hasErrors);
    })();
  }, [onSubmit, setFormStatus, formHasBeenSent]);

  const submitError = useSubmitError();

  return (
    <FormElement onSubmit={handleSubmit}>
      {submitError && (
        <ErrorDisplay error={submitError} />
      )}
      <CaptchaForm />

      <PixPispPaymentInformation />


      <PlaceOrderButtonPisp />

      {!selectedBank && (<PixPaymentInformation />)}

      {selectedBank && (<InformationBox />)}

      <Terms />
    </FormElement>
  );
}
